import { Select } from '@zeiss/beyond-online-react';

import { useLocations } from 'src/hooks';

export interface LocationSelectProps {
  /**
   * Label for the select input component.
   *
   * @defaultValue 'Location'
   *
   */
  label?: string;
  /**
   * "ISO 3166-1 alpha-2" code for the language list
   *
   * @defaultValue 'EN'
   */
  language?: string;
  /**
   * Callback with the "ISO 3166-1 alpha-2" code of the selected country
   */
  onChange: (countryCode: string) => void;
  value: string;
}

export const LocationSelect = ({
  label = 'Location',
  language = 'EN',
  onChange,
  value,
}: LocationSelectProps) => {
  const { locations } = useLocations({ language });

  // Prepend blank entry because we use the Select component in `native` mode
  const options = [{ key: '', label: '' }].concat(
    locations.map(({ id: key, name: label }) => ({ key, label })),
  );

  return (
    <Select label={label} onChange={onChange} options={options} value={value} />
  );
};
